import IconsView from "./icons-view";

const IconsContainer = () => {
  return <IconsView />;
};

export default IconsContainer;
